import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
/**
 * A flexible bottom bar component using composition pattern.
 * Used across different pages for consistent bottom bar styling and layout.
 *
 * Usage:
 * ```tsx
 * <BottomBar>
 *   <BottomBarSection>{leftContent}</BottomBarSection>
 *   <BottomBarSection>{centerContent}</BottomBarSection>
 *   <BottomBarSection>{rightContent}</BottomBarSection>
 * </BottomBar>
 * ```
 */ const BottomBar = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("flex items-center justify-between border-t border-line bg-white px-10 py-4", className),
        ...props
    }));
BottomBar.displayName = "BottomBar";
const BottomBarSection = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("flex items-center gap-4", className),
        ...props
    }));
BottomBarSection.displayName = "BottomBarSection";
export { BottomBar, BottomBarSection };

//# sourceMappingURL=bottom-bar.js.map